export const namespaced = true;
export const state = {
  notifications: [],
};

let nextId = 1;
export const mutations = {
  PUSH(state, notification) {
    state.notifications.push({
      ...notification,
      id: nextId++,
    });
  },
  DELETE(state, notificationToRemove) {
    state.notifications = state.notifications.filter((notification) => notification.id !== notificationToRemove.id);
  },
};

export const actions = {
  add({ commit }, notification) {
    commit('PUSH', notification);
  },
  remove({ commit }, notificationToRemove) {
    commit('DELETE', notificationToRemove);
  },
  success({ commit }, { message, options }) {
    commit('PUSH', { type: 'success', message, ...options });
  },
  notifyFailure({ commit }, { message, options }) {
    return new Promise((resolve) => {
      commit('PUSH', {
        type: 'danger',
        text: { class: 'font-weight-bold' },
        icon: {
          icon: ['far', 'times-circle'],
          size: 'lg',
          class: 'mr-2',
        },
        message,
        ...options,
      });
      resolve();
    });
  },
};
